import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { connect } from "react-redux";
import SideNav from "../SideNav/SideNav";
import { Button, Col, Row } from "react-bootstrap";
import { dbContext } from "../context/db";
import { AuthContext } from "../context/Auth";

import { refreshAccessToken } from "../../Utils/commonApi";

import LoadingSpinner from "../Spinner/Spinner";

import "../ActionCenter";
import { Design } from "./Design";
import "../../responsive.scss";
import { hotjar } from "react-hotjar";

import { getMenuCollapseStatus } from "../../redux/highgroundGlobalState/selectors";
import { createStructuredSelector } from "reselect";
import { menuToggle } from "../../redux/highgroundGlobalState/actions";

import { useSelector } from "react-redux";


import { clearLocalStorage } from "../../Utils/clearLocalStorage";

import Logout from "../Logout/Logout";

import Loginv2 from "../Loginv2/Loginv2";

import NoAccessToHighground from "../Common/NoAccessToHighground";

import SubscriptionBackendHome from "../SubscriptionBackendPortal";
import { APP_ROUTES, ROUTE_PATHS } from "../../constants/app.constants";
import useRespondTo from "../../hooks/respond-to.hook";
import { WindowBreakpoints } from "../../constants/window.constants";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import { ArcElement, Chart, LineElement, PointElement, RadialLinearScale, CategoryScale, LinearScale, Filler, BarElement } from "chart.js";
import { useIdleTimer } from "../use-idle-timer/my-line.chart";

Chart.register(RadialLinearScale, PointElement, LineElement, ArcElement, CategoryScale, LinearScale, Filler, BarElement);

let timer = 0;
let interval = null;

function App(props) {
  const isTablet = useRespondTo(WindowBreakpoints.lg);
  const isMenuCollapse = useSelector((state) => state.global.menuCollapse) || isTablet;
  const userDetails = useSelector((state) => state.user?.userDetail);
  const URLpath = window.location.pathname.split("/");
  const settings_V2_exist = URLpath[1] === "settings" && URLpath[2] === "v2";
  const user_data = JSON.parse(localStorage.getItem("object_Data"));

  const navigate = useNavigate();
  const existingAuth = JSON.parse(localStorage.getItem("userAuthenticated"));
  const [auth, setAuth] = useState(existingAuth);


  useEffect(() => {
    // Run only if there is no token exist in Local storage
    // let userAgent = navigator.userAgent;
    // if(userAgent.match(/firefox|fxios/i) && !window.localStorage.getItem("tokens")){
    //   window.localStorage.clear()
    //   window.location.replace("/login")
    // }

    // Run only if the token is removed from Localstorage
    let runOnce = 0;
    const localStorageSetHandler = function (e) {
      if (
        window.location.pathname.includes("login") ||
        window.location.pathname.includes("signup")
      ) {
        return;
      }
      if (e.key === "tokens") {
        if (runOnce > 0) return;

        runOnce += 1;
        setTimeout(() => {
          runOnce = 0;
        }, 2000);

        if (true) {
          window.localStorage.clear();
          setAuth(false);
 

          navigate(ROUTE_PATHS.authPages.login, {
            state: {
              // redirectUser: true,
              // redirectUrl: `${window.location.pathname}${window.location.search}`,
            },
          });
        }
      }
    };

    document.addEventListener("tokenRemoved", localStorageSetHandler, false);
  }, []);

  // Segment integration
  // window.analytics.identify(userDetails?.UserName || "test", {
  //   userName: userDetails?.Fullname,
  //   userEmail: userDetails?.UserName,
  //   unsubscribed: false,
  // });

  // To find last Pass pop-up and to Fix its UI
  const myInterval = setInterval(startSolving, 1000);
  function startSolving() {
    // var ifrm1 = document.querySelector("[name=LPFrame]");
    var ifrm1 = document.querySelector("[data-lastpass-iframe='true']");

    // console.log(ifrm1);
    if (ifrm1) {
      const tets = ifrm1?.parentElement;
      // console.log(tets);
      tets.style.zoom = 1.5;
      setTimeout(() => clearInterval(myInterval), 100);
    } else {
      setTimeout(() => clearInterval(myInterval), 15000);
    }
  }
  // ---------------------

  // Code to clear cache during page Refresh

  // const clearCacheData = () => {
  //   caches.keys().then((names) => {
  //     names.forEach((name) => {
  //       caches.delete(name);
  //       console.log("caches", name);
  //     });
  //   });
  //   console.log("Complete Cache Cleared");
  // };

  // useEffect(() => {
  //   clearCacheData();
  // }, []);

  // get Action Centre Data

  // --FOR PRODUCTION---
  hotjar.initialize(2974856, 6);

  //-- FOR STAGING
  hotjar.initialize(2975178, 6);

  // Identify the user
  hotjar.identify("USER_ID", { userProperty: user_data?.UserDetail?.UserName });

  // Add an event
  hotjar.event("button-click");

  // Update SPA state
  hotjar.stateChange("/");

  //Constants
  const CURRENT_URL = useLocation().pathname;
  if (CURRENT_URL.includes("Logout") || CURRENT_URL.includes("logout")) {
    console.log("Routing towards Logout");
    let element = document.getElementById("root").firstChild;

    if (element) {
      element.classList.add("fadeOut");
    }

    setTimeout(() => {
      clearLocalStorage();
      // window.location.href = "/login";
      return <Navigate to="/login" />;
    }, 500);
  }

  //States and Persistant Storages
  const existingTokens = JSON.parse(localStorage.getItem("tokens"));

  const existingDb = JSON.parse(localStorage.getItem("object_Data"));
  const existingUserType = JSON.parse(localStorage.getItem("userType"));
  const existingDrilldown = JSON.parse(localStorage.getItem("techDrilldown"));
  const existingUserMessage = JSON.parse(
    localStorage.getItem("user_MessageObj")
  );

  const [dbObj, setdbObject] = useState(existingDb);
  const [authTokens, setAuthTokens] = useState(existingTokens);
  const [qrCode, setQrCode] = useState();

  const [userType, setUserType] = useState(existingUserType);
  const [drilldown, setDrillDown] = useState(existingDrilldown);
  const [messageEncrypt, setMessageEncrypt] = useState(existingUserMessage);
  const [loadingScreen, setLoadingScreen] = useState();
  const pageScreen = JSON.parse(localStorage.getItem("currentUrl"));

  // automatic logout session
  function setInetrvalFunc() {
    if (
      window.location.pathname.includes("login") ||
      window.location.pathname.includes("signup")
    ) {
      return;
    }
    // return;
    timer++;
    const tokenTime = window.localStorage.getItem("token_time");

    if (tokenTime) {
      let currentTime = Math.floor(Date.now() / 60000);

      if (currentTime - tokenTime >= 20) {
        refreshAccessToken((new_token) => {
          setTokens(new_token);
        });
      }
    }
    const USERTYPE = JSON.parse(localStorage.getItem("userType"));
    if (timer >= 28 && timer < 30 && USERTYPE !== 555555) {
      navigate(ROUTE_PATHS.authPages.sessionExpiry);
    } else if (timer >= 30) {
      setAuth(false);
      console.log("Local Strogare is Cleared 1");
      localStorage.clear();
      navigate(ROUTE_PATHS.authPages.login, {
        state: {
          redirectUser: true,
          redirectUrl: `${window.location.pathname}${window.location.search}`,
        },
      });
    }
  }

  useEffect(() => {
    setAuthTokens(existingTokens);
  }, [existingTokens]);

  useEffect(() => {
    if (authTokens) {
      if (interval) clearInterval(interval);

      interval = setInterval(setInetrvalFunc, 60000);

      Design();
    }
  }, [authTokens]);

  /**
   * Executes on Mouse Move & Space key press
   */

  function handleOnAction() {
    if ((authTokens, auth)) {
      timer = 0;
    }
  }

  useIdleTimer({
    timeout: 1800000,
    onAction: handleOnAction,
    debounce: 500,
  });

  // automatic logout session

  const [ViewingMSP, setViewingMSP] = useState(
    localStorage.getItem("ViewingMSP")
  );
  const [ViewingMSPPageType, setViewingMSPPageType] = useState(
    localStorage.getItem("ViewingMSPPageType")
  );
  const [impersinatingDetails, setImpersinatingDetails] = useState(
    JSON.parse(localStorage.getItem("impersinatingDetails"))
  );

  const setImpersinatingDetailsObj = (data) => {
    if (!data) localStorage.removeItem("impersinatingDetails");
    else localStorage.setItem("impersinatingDetails", JSON.stringify(data));
    setImpersinatingDetails(data);
  };

  const setViewingMspObj = (data) => {
    if (!data) localStorage.removeItem("ViewingMSP");
    else localStorage.setItem("ViewingMSP", JSON.stringify(data));
    setViewingMSP(data);
  };
  const setViewingMspPageTypeObj = (data) => {
    if (!data) localStorage.removeItem("ViewingMSPPageType");
    else localStorage.setItem("ViewingMSPPageType", JSON.stringify(data));
    setViewingMSPPageType(data);
  };

  const setDrilldownObj = (data) => {
    // Testing
    if (!data) localStorage.removeItem("techDrilldown");
    else localStorage.setItem("techDrilldown", JSON.stringify(data));
    setDrillDown(data);
  };

  const setDBObj = (data) => {
    if (!data || data === null || data === undefined) {
      localStorage.removeItem("object_Data");
      return;
    } else localStorage.setItem("object_Data", JSON.stringify(data));
    setdbObject(data);
  };

  const setUserTypeObj = (data) => {
    if (!data) localStorage.removeItem("userType");
    else localStorage.setItem("userType", JSON.stringify(data));
    setUserType(data);
  };

  const setTokens = (data) => {
    if (!data) localStorage.removeItem("tokens");
    else localStorage.setItem("tokens", JSON.stringify(data));
    setAuthTokens(data);
  };

  const setAuths = (data) => {
    if (!data) localStorage.removeItem("userAuthenticated");
    else localStorage.setItem("userAuthenticated", JSON.stringify(data));
    setAuth(data);
  };

  const setMessage = (data) => {
    if (!data) localStorage.removeItem("user_MessageObj");
    else localStorage.setItem("user_MessageObj", JSON.stringify(data));
    setMessageEncrypt(data);
  };

  function showVerifyEmailBanner() {
    let showDashboardLoader = false;
    try {
      let dashboard_status = localStorage.getItem("dasboardLoader");
      if (dashboard_status) {
        showDashboardLoader = JSON.parse(
          localStorage.getItem("dasboardLoader")
        );
      }
    } catch (err) {
      showDashboardLoader = false;
    }

    if (URLpath[1] === "login") {
      return false;
    } else if (URLpath[1] === "logout") {
      return false;
    } else if (URLpath[1] === "signup") {
      return false;
    }

    // else if (URLpath[1] === "mspv2") {
    //   return false;
    // }
    else if (URLpath[1] === "supplier-profiler") {
      return false;
    } else if (URLpath[1] === "assessment-frameworks") {
      return false;
    }

    // else if (showDashboardLoader === true) {
    // }
    else if (URLpath[1] === "mspsettingsv2") {
      return false;
    } else if (URLpath[1] === "clientmspsettingsv2") {
      return false;
    } else if (showDashboardLoader === true) {
      return true;
    } else {
      return true;
    }
  }


const location = useLocation()
const blocked_paths_for_intercomm = ["login", "logout", "signup"];
useEffect(() => {
  const current_url = location.pathname?.split("/")?.[1];

  if (blocked_paths_for_intercomm.includes(current_url)) {
    console.log("intercomm removed");
    window.Intercom("update", { hide_default_launcher: true });
  } else {
    console.log("intercomm Enabled");
    window.Intercom("update", { hide_default_launcher: false });
  }
}, [location]);
  

  return (
    <AuthContext.Provider
      value={{
        authTokens,
        setAuthTokens: setTokens,
        qrCode,
        setQrCode,
        auth,
        setAuth: setAuths,
        userType,
        setUserType: setUserTypeObj,
        drilldown,
        setDrillDown: setDrilldownObj,
        messageEncrypt,
        setMessageEncrypt: setMessage,
        loadingScreen,
        setLoadingScreen,
      }}
    >
      <dbContext.Provider
        value={{
          dbObj,
          setdbObject: setDBObj,
          ViewingMSP,
          setViewingMSP: setViewingMspObj,
          impersinatingDetails,
          setImpersinatingDetails: setImpersinatingDetailsObj,
          ViewingMSPPageType,
          setViewingMSPPageType: setViewingMspPageTypeObj,
        }}
      >
        <div
          className={`h-100 ${
            URLpath[1] !== "settings" && isMenuCollapse
              ? "smallSideMenu"
              : "largeSideMenu"
          }
          
          ${CURRENT_URL.includes("MSP") ? "MSP" : ""} 
          
          ${pageScreen ? pageScreen.name : "empty"}
          
          -Screen-Wrapper`}
          id="mainRow"
        >
          {loadingScreen ? (
            <span>
              <LoadingSpinner />
            </span>
          ) : (
            ""
          )}
          <div
            className="fullHeight"
            id="mainBody"
            style={{
              paddingTop: ` ${
                URLpath[1] === "settings"
                  ? "calc(3.3rem + 38px)"
                  : (userDetails?.AccountVerified === false ||
                      userDetails?.ShowConfirmVerified === true) &&
                    showVerifyEmailBanner()
                  ? "38px"
                  : ""
              }       `,
              background: "white",
            }}
          >
            <Routes>
              <Route path={APP_ROUTES.authPages.logout} element={<Logout />} />
              <Route
                path={APP_ROUTES.authPages.noAccess}
                element={<NoAccessToHighground />}
              />
              <Route path={APP_ROUTES.authPages.login} element={<Loginv2 />} />
              <Route path={`${APP_ROUTES.subscriptionPortal}/*`} element={<SubscriptionBackendHome />} />
              <Route 
                path="*" 
                element={
                  <Navigate 
                    to={
                      authTokens && auth 
                        ? ROUTE_PATHS.subscriptionPortalPages.overview
                        : ROUTE_PATHS.authPages.login
                    } 
                    replace 
                  />
                } 
              />
            </Routes>
          </div>
        </div>
      </dbContext.Provider>
    </AuthContext.Provider>
  );
}

const mapStateToProps = createStructuredSelector({
  isMenuCollapse: getMenuCollapseStatus(),
});

const compose = connect(mapStateToProps, { menuToggle });

export default compose(App);

export const NoAccessUI = ({ type }) => {
  const navigate = useNavigate();
  const objectData = window.localStorage.getItem("object_Data");
  var UserEmail = null;
  var mspDetail = null;
  if (objectData) {
    UserEmail = JSON.parse(objectData)?.UserDetail?.UserName;
    mspDetail = JSON.parse(objectData)?.mspDetail;
  }

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ marginTop: "9rem" }}
    >
      {/* <img alt="" src="/images/supply-chain/supply-lock.svg" className="mb-2" /> */}
      <div className="d-flex align-items-center f-16 f-600 mb-5">
        <div className="mr-2 position-relative">
          <img
            alt=""
            src={mspDetail?.logo ?? "/images/user-logo.svg"}
            width={40}
            height={40}
            className="radius-4"
            onError={({ currentTarget }) => {
              currentTarget.onerror = null; // prevents looping
              currentTarget.src = "/images/user-logo.svg";
            }}
            // (e) => (e.target.src = "/images/user-logo.svg")
          />
          <img
            alt=""
            src="/images/settings-v2/settingwheel.svg"
            width={18}
            height={18}
            className="position-absolute "
            style={{
              top: "100%",
              transform: "translate(-50%,-50%)",
              zIndex: 2,
            }}
          />
        </div>
        {mspDetail?.name}
      </div>
      <div className=" f-black mb-3 f-24 f-700 highground-royal-font">
        Access locked
      </div>
      <div className="f-darkgrey mb-4 text-center">
        Want in? Ask your service provider for permission or login with <br />{" "}
        another credentials.
      </div>
      {UserEmail && (
        <div className="f-grey mb-3">
          You are signed in as <span className="f-600">{UserEmail}</span>
        </div>
      )}
      <Button
        className="hg-blue-btn radius-2"
        onClick={() => {
          window.localStorage.clear();
          window.location.href = "/login";
        }}
      >
        Switch account
      </Button>

      <div
        className="f-darkgrey"
        style={{
          position: "fixed",
          bottom: "26px",
        }}
      >
        <p className="lgnGreyText terms">
          © 2024 HighGround. &nbsp;
          <a
            href="https://www.highground.io/privacy_policy/"
            target="_blank"
            rel="noopener noreferrer"
            className="f-12 f-500"
          >
            &nbsp;<u>Privacy Policy</u>
          </a>
          &nbsp; &nbsp;
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.highground.io/highground-terms-and-conditions/"
            className="f-12 f-500"
          >
            <u> Terms & Conditions</u>
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export function UserSystemSettingsBlocked() {
  const objectData = window.localStorage.getItem("object_Data");

  if (objectData) {
    let accessData = JSON.parse(objectData)?.accessData;

    if (
      accessData?.AccessState_SystemSettings === 0 &&
      accessData?.Override === true
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export function accessAllowed(_accessSection) {
  let objectData = JSON.parse(localStorage.getItem("object_Data") ?? "{}");

  if (!objectData || !objectData?.accessData) return false;
  if (!objectData?.accessData.hasOwnProperty(_accessSection)) return false;
  if (objectData?.accessData?.Override === true) {
    if (objectData?.accessData[_accessSection] === 0) {
      return false;
    } else {
      return true;
    }
  } else {
    return true;
  }
}
export function viewOnlyAccess(_accessSection) {
  let objectData = JSON.parse(localStorage.getItem("object_Data") ?? "{}");

  if (!objectData || !objectData?.accessData) return false;
  if (!objectData?.accessData.hasOwnProperty(_accessSection)) return false;
  if (objectData?.accessData?.Override === true) {
    if (objectData?.accessData[_accessSection] === 1) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export function editAccess(_accessSection) {
  let objectData = JSON.parse(localStorage.getItem("object_Data") ?? "{}");

  if (!objectData || !objectData?.accessData) return false;
  if (!objectData?.accessData.hasOwnProperty(_accessSection)) return false;
  if (objectData?.accessData?.Override === true) {
    if (objectData?.accessData[_accessSection] === 3) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function accessStateValue(_accessSection) {
  let objectData = JSON.parse(localStorage.getItem("object_Data") ?? "{}");

  if (!objectData || !objectData?.accessData) return false;
  if (!objectData?.accessData.hasOwnProperty(_accessSection)) return false;
  if (objectData?.accessData?.Override === true) {
    return objectData?.accessData[_accessSection];
  } else {
    return null;
  }
}

export const NO_ACCESS_TEXT =
  "This feature is managed by your service provider. ";

// export function HGHighlightText(text, searchTerm) {
//   console.log(text, searchTerm);
//   console.log(!searchTerm.trim(), "andar gya?");
//   if (!searchTerm.trim()) return text;
//   const regex = new RegExp(`(${searchTerm})`, "gi");
// console.log(text.split(regex),"text.split(regex)")

// return text.replace(
//   new RegExp(searchTerm, "gi"),
//   (match) => `<span class="list-highlight-class">${match}</span>`
// )
//   return text.split(regex).map((part, index) => {
//     console.log(part, "regex.test(part)");
//     return regex.test(part) ? (
//       <span className="list-highlight-class">{part}</span>
//     ) : (
//       part
//     );
//   });
// }

// export function HGHighlightText(text, searchTerm) {
//   try{

//   if (!searchTerm?.trim()) return text;

//   const regex = new RegExp(`(${searchTerm})`, "gi");

//   return text?.split(regex).map((part, index) => {
//     return regex.test(part) ? (
//       <span key={index} className="list-highlight-class">
//         {part}
//       </span>
//     ) : (
//       part
//     );
//   });
// }catch(err){
//   console.log(err)
//   return text
// }
// }

export function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

// export function HGHighlightText(text, searchTerm) {
//   if (!searchTerm?.trim()) {
//     return text;
//   }
//   const escapedSearchTerm = escapeRegexCharacters(searchTerm);
//   const regex = new RegExp(`(${escapedSearchTerm})`, "gi");

//   return text.replace(regex, (match, offset, string) => (
//     `<span class="list-highlight-class">${match}</span>`
//   ));
// }

// export function HGHighlightText(text, searchTerm) {
//   try {
//     if (!searchTerm?.trim()) return text;

//     const regex = new RegExp(`(${searchTerm})`, "gi");

//     return text?.replace(regex, (match, index) => (
//       `<span key=${index} className="list-highlight-class">${match}</span>`
//     ));
//   } catch(err) {
//     console.log(err)
//     return text
//   }
// }

//  export function HGHighlightText(text, searchString) {
//    if (searchString) {
//      // Escape special characters in the search string
//      const escapedSearchString = searchString.replace(
//        /[.*+?^${}()|[\]\\]/g,
//        "\\$&"
//      );

//      // Create a regular expression with the search string and case-insensitive flag
//     //  const regex = new RegExp(escapedSearchString, "gi");
//      const regex = new RegExp(searchString, "gi");

//      // Replace the search string with a highlighted version
//      const highlightedText = text.replace(
//        regex,
//        (match) => `<span class="list-highlight-class">${match}</span>`
//      );

//      return highlightedText;
//    } else {
//      return text;
//    }
//  }

export function HGHighlightFuzzyText(text, searchString) {
  try {
    if (!searchString.trim()) {
      return text;
    }

    // Split search string into individual characters
    const searchCharacters = searchString.split("");

    // Escape special characters in search string for regex
    const escapedSearch = searchCharacters.map(char => char.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join("");

    // Construct regex pattern to match each character with optional commas
    const regexPattern = `(${escapedSearch.split("").join("|")}|,)`;

    const output = text.replace(
      new RegExp(regexPattern, "gi"),
      (match) => {
        if (match === ",") {
          return match; // Keep commas as they are
        } else {
          return `<span class="list-highlight-class">${match}</span>`; // Highlight search characters
        }
      }
    );

    return output;
  } catch (err) {
    console.log(err);
  }
}
export function checkAccessSection(_accessSection, clientDetail) {
  let accessName = _accessSection;

  if (clientDetail && clientDetail?.isSameOrg === true) {
    accessName = _accessSection.replace("AccessState", "AccessState_Own");
  }
  return accessName;
}
export function getAccessStateValue(_accessSection, clientDetail) {
  let objectData = JSON.parse(localStorage.getItem("object_Data") ?? "{}");

  let accessName = checkAccessSection(_accessSection, clientDetail);

  if (!objectData || !objectData?.accessData) return 0;
  if (!objectData?.accessData.hasOwnProperty(accessName)) return 0;
  if (objectData?.accessData?.Override === true) {
    return objectData?.accessData[accessName];
  } else {
    return 99;
  }
}



export function HGHighlightText(text, searchString) {
  try {
    if (!searchString.trim()) {
      return text;
    }

    const output = text.replace(
      new RegExp(searchString, "gi"),
      (match) => `<span class="list-highlight-class">${match}</span>`
    );

    return output;
  } catch (err) {
    console.log(err);
  }

  return;

  if (searchString?.length > 0) {
    // Escape special characters in the search string
    const escapedSearchString = searchString.replace(
      /[.*+?^${}()|[\]\\]/g,
      "\\$&"
    );

    // Create a regular expression with the search string and case-insensitive flag
    const regex = new RegExp(
      `\\b${escapedSearchString}\\b|${escapedSearchString}`,
      "gi"
    );

    // Replace the search string with a highlighted version only if it matches
    const highlightedText = text.replace(
      regex,
      (match) => `<span class="list-highlight-class">${match}</span>`
    );
    if (text === "IT Support" && searchString === "su") {
      console.log(highlightedText, "text");
    }
    return highlightedText;
  } else {
    return text;
  }
}
